import React from "react";
import { Grid, styled, Box } from "@mui/material";
import { ReactComponent as Earth } from "../../resources/images/svg/earth.svg";
import logo from "../../resources/images/svg/inexplore-logo-white.svg";
import BurgerButton from "./BurgerButton";
import MenuPanelContent from "./MenuPanelContent";
import UniversesList from "./UniversesList";
import RainbowDivider from "../misc/RainbowDivider";

const Wrapper = styled(Grid)(({ theme }) => {
  return {
    position: "fixed",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    zIndex: 30,
  };
});
const Container = styled(Grid)(({ theme }) => {
  return {
    width: "100%",
    height: "75px",
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    background: "#0D0034",
    // padding: "0 10px",
    zIndex: 32,
  };
});

const MenuPanel = styled(Box)(({ theme }) => {
  return {
    position: "fixed",
    height: "calc(100% - 2.55rem)",
    width: "100%",
    background: "#0D0034",

    top: "75px",
    paddingTop: theme.spacing(2),
    transition: "left 0.3s ease-out",
    left: "-100%",
    "&.isOpen": {
      left: 0,
    },
  };
});

const SafeAreaView = styled(Box)(() => {
  return {
    height: 70,
  };
});

const SmallHeader = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isUniverseOpen, setIsUniverseOpen] = React.useState(false);

  const redirect = (url) => {
    window.location.href = `${process.env.REACT_APP_INEXPLORE_URL}${url}`;
  };

  return (
    <React.Fragment>
      <Wrapper>
        <Container>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              height: "72px",
              padding: "0 10px",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Grid
              item
              onClick={() => redirect("/")}
              sx={{ cursor: "pointer" }}
              ml={1}
            >
              <img
                src={logo}
                className=""
                alt="logo"
                style={{ height: "54px", width: "55vw" }}
              />
            </Grid>
            <Grid item sx={{ paddingX: "9.5px" }}>
              <BurgerButton isOpen={isOpen} setIsOpen={setIsOpen} />
            </Grid>
            <MenuPanel className={`${!!isOpen ? "isOpen" : "closed"}`}>
              <MenuPanelContent redirect={redirect} />
            </MenuPanel>
          </Box>
          <RainbowDivider />
        </Container>
      </Wrapper>
      <SafeAreaView />
    </React.Fragment>
  );
};

export default SmallHeader;
